function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BlockTeaserTemplate = require('./block-teaser.template');
var _require = require('../explorer-format'),
  formatBlocksForTeaser = _require.formatBlocksForTeaser;
var BlockTeaser = /*#__PURE__*/function () {
  function BlockTeaser(app, mod) {
    _classCallCheck(this, BlockTeaser);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(BlockTeaser, [{
    key: "render",
    value: function render(container) {
      if (!container) {
        return;
      }
      var loading = !this.mod.blocksReady;
      var error = this.mod.blocksError ? this.app.browser.escapeHTML(this.mod.blocksError) : null;
      var blocks = loading ? [] : formatBlocksForTeaser(this.app, this.mod.blocks || []);
      this.app.browser.replaceElementContentBySelector(BlockTeaserTemplate({
        blocks: blocks,
        loading: loading,
        error: error,
        loadingMessage: 'Fetching block data. Please be patient while we load the latest blocks from the network.'
      }), container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      document.querySelectorAll('.block-teaser .explorer-block-card[data-block-hash]').forEach(function (el) {
        var navigate = function navigate(event) {
          var _event$target, _event$preventDefault;
          if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.closest('.explorer-pubkey-link')) {
            return;
          }
          event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
          var hash = el.getAttribute('data-block-hash');
          if (hash) {
            _this.mod.renderBlock(hash);
          }
        };
        el.onclick = navigate;
        el.onkeydown = function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(event);
          }
        };
      });
    }
  }]);
}();
module.exports = BlockTeaser;